import { createSlice } from "@reduxjs/toolkit";
import { resetSearchResults } from "../../../system/store/reset.slice";

const initialState = {
  searchResults: null,
};

export const searchPatientSlice = createSlice({
  name: "search-patient-slice",
  initialState,
  reducers: {
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetSearchResults, () => initialState);
  },
});

export const { setSearchResults } = searchPatientSlice.actions;

export default searchPatientSlice.reducer;
